import {
  CandidateState,
  ShortlistedCandidateState,
  StateMap,
} from "../../../lib/constant.ts";
import { CandidateListsType } from "./type.ts";

export const webCandidatesInitialState: CandidateListsType = {
  list: {
    curated: [],
    completed: [],
    invited: [],
    preInvite: [],
    unqualified: [],
    misc: [],
    rejected:[],
    all: [],
  },
  metadata: {},
  page: 1,
  sortBy: "-last_status_updated_on",
  sourceUser: "",
  stateFilter: "",
  loading: false,
  error: null,
};

export const phoneCandidatesInitialState: CandidateListsType = {
  list: {
    curated: [],
    completed: [],
    invited: [],
    unqualified: [],
    misc: [],
    rejected:[],
  },
  metadata: {},
  page: 1,
  sortBy: "-last_status_updated_on",
  sourceUser: "",
  loading: false,
  error: null,
};

export const PageTitles = {
  All: "All",
  Curated: "Curated",
  Interviewed: "Interview Completed",
  InviteSent: "Invited",
  PreInvite: "Not Yet Invited",
  Unqualified: "Unqualified",
  Others: "Miscellaneous",
  Rejected: "Rejected",
};

export const TabsList = {
  Curated: [
    { name: "All", status: "" },
    {
      name: "Need Review",
      status: ShortlistedCandidateState.NeedsApproval,
    },
    { name: "Selected", status: ShortlistedCandidateState.Selected },
    { name: "Rejected", status: ShortlistedCandidateState.Rejected },
    {
      name: "Scheduled",
      status: ShortlistedCandidateState.Scheduled,
    },
    { name: "Saved for later", status: ShortlistedCandidateState.Save },
  ],
  web: [
    {
      name: "All",
      status: "",
      to: StateMap.All,
    },
    {
      name: "Curated",
      status: "",
      to: StateMap.Curated,
    },
    {
      name: "Interview Completed",
      status: CandidateState.Interviewed,
      to: StateMap.Interviewed,
    },
    {
      name: "Invited",
      status: CandidateState.InviteSent,
      to: StateMap.InviteSent,
    },
    {
      name: "Not Yet Invited",
      status: CandidateState.PreInvite,
      to: StateMap.PreInvite,
    },
    {
      name: "Unqualified",
      status: CandidateState.Unqualified,
      to: StateMap.Unqualified,
    },
    {
      name: "Rejected",
      status: CandidateState.Rejected,
      to: StateMap.Rejected,
    },
    {
      name: "Miscellaneous",
      status: CandidateState.Others,
      to: StateMap.Others,
    },
  ],
  phone: [
    {
      name: "All",
      status: "",
      to: StateMap.All,
    },
    {
      name: "Curated",
      status: "",
      to: StateMap.Curated,
    },
    {
      name: "Interview Completed",
      status: CandidateState.Interviewed,
      to: StateMap.Interviewed,
    },
    {
      name: "Invited",
      status: CandidateState.InviteSent,
      to: StateMap.InviteSent,
    },
    {
      name: "Unqualified",
      status: CandidateState.Unqualified,
      to: StateMap.Unqualified,
    },
    {
      name: "Miscellaneous",
      status: CandidateState.Others,
      to: StateMap.Others,
    },
  ],
};
